module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Οδός","flags":["TRACK"],"track":"Street Address"}}